import React from "react"
import { Link } from "gatsby"

/**
 * Deduplicate targets; prefer longer labels first for matching.
 * @param {{ label: string, href: string }[]} targets
 */
export function normalizeFaqLinkTargets(targets) {
  const seen = new Set()
  const out = []
  for (const t of targets) {
    const label = String(t.label || "").trim()
    if (!label || seen.has(label.toLowerCase())) continue
    seen.add(label.toLowerCase())
    out.push({ label, href: t.href })
  }
  return out.sort((a, b) => b.label.length - a.label.length)
}

/**
 * Turn plain answer text into nodes with internal links for known topic/platform names.
 */
export function FaqAnswer({ text, linkTargets }) {
  if (text == null || text === "") return null
  const targets = normalizeFaqLinkTargets(linkTargets || [])
  if (!targets.length) return <>{text}</>

  const nodes = []
  let remaining = String(text)

  while (remaining.length) {
    let found = null
    let idx = Infinity
    let foundLen = -1
    for (const t of targets) {
      const j = remaining.indexOf(t.label)
      if (j === -1) continue
      const before = j > 0 ? remaining[j - 1] : ' '
      const after =
        j + t.label.length < remaining.length ? remaining[j + t.label.length] : ' '
      const singleToken = !t.label.includes(' ')
      if (
        singleToken &&
        (/[a-zA-Z0-9]/.test(before) || /[a-zA-Z0-9]/.test(after))
      ) {
        continue
      }
      if (j < idx || (j === idx && t.label.length > foundLen)) {
        idx = j
        found = t
        foundLen = t.label.length
      }
    }
    if (!found) {
      nodes.push(remaining)
      break
    }
    if (idx > 0) {
      nodes.push(remaining.slice(0, idx))
    }
    nodes.push(
      <Link
        to={found.href}
        className="text-rose-600 font-medium underline underline-offset-2 hover:text-rose-700"
      >
        {found.label}
      </Link>
    )
    remaining = remaining.slice(idx + found.label.length)
  }

  return nodes.map((n, i) =>
    typeof n === "string" ? (
      <span key={`faq-t-${i}`}>{n}</span>
    ) : (
      React.cloneElement(n, { key: `faq-l-${i}` })
    )
  )
}
